import {
    clone as _clone,
    assign as _assign
} from 'lodash';

import {
    USER_GET_GROUPS,
    USER_UPDATE_ALL,
    USER_UPDATE_GROUPS,
    USER_GET_SINGLE,
    USER_UPDATE_SINGLE,
    USER_ADD_TO_SINGLE
} from '../constants/user.js';

export const initialState = {
    users: {},
    groups: {}
};

export function userReducer( state = initialState, action ) {

    let users;

    switch ( action.type ) {

        case USER_UPDATE_ALL:

            users = Object.assign( {}, state.users, action.users );
            return { ...state, users };

        case USER_UPDATE_SINGLE:

            users = _clone( state.users );
            users[ action.userID ] =_assign( users[ action.userID ], action.userDetails[ action.userID ] );

            return { ...state, users };

        case USER_ADD_TO_SINGLE:
            users = _clone( state.users );
            users[ action.userID ] = action.user;
            return { ...state, users };

        case USER_GET_SINGLE:

            return Object.assign( {}, state, action.user );

        case USER_UPDATE_GROUPS:

            users = _clone( state.users );
            users[ action.userID ].groups = action.groups;

            return { ...state, users };

        case USER_GET_GROUPS:
            return { ...state, groups: action.groups }

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/users.js